<template>

  <v-card class="back" style="height: 480px">

    <v-layout fill-height>

      <v-flex xs12>

        <v-layout column fill-height>

          <scroll-area>

            <template slot="header">

              <v-toolbar dark color="secondary" dense flat>

                <v-toolbar-title>

                  <span v-if="data.name" class="body-2 text-uppercase">{{$t('replace')}} {{data.name}} </span>
                  <span v-if="selected" class="body-2 text-uppercase">{{$t('into')}}  {{selected.name}} </span>

                </v-toolbar-title>

              </v-toolbar>

            </template>

            <template slot="body">

              <v-layout column fill-height justify-start>

                <loading-circle
                  :show="loader"
                />

                <equipment-tree
                  :expandAll="false"
                  :showStatuses="false"
                  :subscribe="false"
                  :nodes="getTree"
                  :data="getData"
                  :mode="'replace'"
                  @selected="(payload) => onSelected(payload)"
                />

              </v-layout>

            </template>

            <template slot="footer">

              <v-layout fill-height>

                <v-flex xs2>

                </v-flex>

                <v-layout fill-height justify-end>

                  <v-btn dark small color="primary"
                    v-if="selected" 
                    :data-testid="$options.name + '__btn__' + 'replace'"
                    @click="replace">
                      {{$t('replace')}}
                  </v-btn>

                  <v-btn dark small outline color="blacktext"
                    :data-testid="$options.name + '__btn__' + 'cancel'"
                    @click="()=>{$emit('close')}">
                      {{$t('cancel')}}
                  </v-btn>

                </v-layout>

              </v-layout>

            </template>

          </scroll-area>

        </v-layout>

      </v-flex>

    </v-layout>

  </v-card>

</template>

<script lang="ts">
import Vue from 'vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import equipmentTree from '@/nms/components/equipment/equipment-tree.vue'

// Типы
interface TreeNode {
  $id?: string
  id?: string
  name?: string
  cls?: string
  children?: TreeNode[]
  disabled?: boolean
  [key: string]: any
}

interface DataProps {
  $id?: string
  [key: string]: any
}

interface BridgeObject {
  $id?: string
  getParent?: () => Promise<TreeNode>
  move?: (target: TreeNode) => Promise<any>
  [key: string]: any
}

export default Vue.extend({
  name: 'REPLACE_CARD',

  components: {
    loadingCircle,
    scrollArea,
    equipmentTree,
  },

  props: {
    data: {
      type: Object as () => DataProps,
      default: () => ({})
    },
  },

  data(): {
    loader: boolean
    selected: TreeNode | null
    locationsTree: TreeNode[]
  } {
    return {
      loader: true,
      selected: null,
      locationsTree: []
    }
  },

  computed: {
    getTree(): TreeNode[] {
      const processTree = (arr: TreeNode[]): TreeNode[] => {
        return arr.map(item => {
          if (item.$id === this.data.$id) {
            item.disabled = true
          }
          if (item.children?.length) {
            processTree(item.children)
          }
          return item
        })
      }
      return processTree(this.locationsTree)
    },

    getData(): DataProps {
      return this.data
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.locationsTree = []
      this.loadLocations()
    },

    async loadLocations(): Promise<void> {
      try {
        const obj = await this.$bridge.getByPath('/physical')
        if (obj) {
          const children = await obj.getLinks({ only: ['location'] }) as TreeNode[]
          if (children) {
            this.locationsTree = children
          }
        }
        this.loader = false
      } catch (err) {
        this.loader = false
      }
    },

    async replace(): Promise<void> {
      try {
        this.setLoader('replaceCard', true)
        const obj = await this.$bridge.getObjectById(this.data.$id) as BridgeObject

        if (obj) {
          const oldParent = await obj.getParent?.()
          const moved = await obj.move?.(this.selected)

          await this.$store.dispatch('loadChildren', this.selected)
          await this.$store.dispatch('loadChildren', oldParent)
          await this.$store.dispatch('loadChildren', (this.$store.state.devices.treeActive as TreeNode[])[0])
          this.$store.dispatch('activeCabinet', moved)

          this.$emit('close')
        } else {
          this.$emit('close')
        }
        this.setLoader('replaceCard', false)
      } catch (err) {
        this.$errorHandler(err)
        this.setLoader('replaceCard', false)
      }
    },

    onSelected(payload: TreeNode | null): void {
      this.selected = payload || null
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style lang="css" scoped>
</style>
